<template>
    <div id="purchase-tracker" data-order="$ProcessedOrderID">
        <div v-if="getSessionOrder && getSessionOrder.ID" :class="purchaseTracking(getSessionOrder)"></div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "PurchaseTracker",
    props: {
        id: {type: String}
    },
    computed: {
        ...mapGetters(['getSessionOrder']),
    },
    methods: {
        ...mapActions(['fetchSessionOrder']),
        purchaseTracking(order) {
            let items = order.Items,
                productData = [];
            items.forEach((item) => {
                let product = item.Product;
                productData.push({
                    'name': product.Title,
                    'id': product.ID,
                    'price': product.LocalisedPrice,
                    'category': product.ProductType,
                    'quantity': item.Quantity,
                });
            });

            let shippingMod = order.Modifiers.find(m => m.Title === "Shipping");
            let couponMod = order.Modifiers.find(m => m.Title === "Discount");
            let discountMod = order.Modifiers.find(m => m.Title === "Member Discount");
            let taxMod = order.Modifiers.find(m => m.Title === "Tax (included)");

            /*if (this.$gtm.enabled()) {
                window.dataLayer?.push({ecommerce: null});
                window.dataLayer?.push({
                    'ecommerce': {
                        'purchase': {
                            'actionField': {
                                'id': order.ID,
                                'affiliation': 'Online Store',
                                'revenue': order.Total,
                                'tax': taxMod ? taxMod.Amount : '0',
                                'shipping': shippingMod ? shippingMod.Amount : '0',
                                'discount': discountMod ? discountMod.Amount : '0',
                                'coupon': couponMod ? couponMod.Amount : '0',
                            },
                            'products': productData
                        }
                    }
                });
            }*/
        }
    },
    created() {
        if (this.id > 0) {
            this.fetchSessionOrder(this.id);
        }
    }
}
</script>
